module.exports = __webpack_public_path__ + "static/img/foot_img.1bd1739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/foot_img.png
// module id = g5QU
// module chunks = 17